
import React from 'react';
import { motion } from 'framer-motion';
import { PRODUCT_DETAILS, WHATSAPP_URL, IMAGES } from '../constants';

const Hero: React.FC = () => {
  return (
    <section id="inicio" className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-24 lg:pt-16 lg:pb-40 flex flex-col lg:flex-row items-center gap-12">
        <motion.div 
          className="lg:w-1/2 text-center lg:text-left z-10"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <motion.h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Elegancia y Modernidad <br />
            <span className="text-slate-500">Para tu Hogar</span>
          </motion.h1>
          
          <motion.p 
            className="text-lg text-slate-600 mb-8 max-w-xl mx-auto lg:mx-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            Descubre la sofisticación del acero inoxidable 304 combinado con la pureza del vidrio templado. Un mueble diseñado para durar toda la vida.
          </motion.p>
          
          <motion.div 
            className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <motion.div 
              className="bg-slate-100 p-4 rounded-xl border border-slate-200 relative"
              whileHover={{ y: -5 }}
            >
              <span className="block text-slate-400 text-sm line-through font-medium">Regular: {PRODUCT_DETAILS.priceRegular}</span>
              <span className="block text-3xl font-bold text-slate-900">Oferta: {PRODUCT_DETAILS.priceOffer}</span>
              
              <motion.div 
                className="absolute -top-3 -right-3 bg-red-600 text-white text-[10px] font-bold py-1 px-2 rounded-full shadow-lg"
                animate={{ scale: [1, 1.1, 1], rotate: [0, 5, -5, 0] }}
                transition={{ repeat: Infinity, duration: 2 }}
              >
                SOLO HOY
              </motion.div>
            </motion.div>
          </motion.div>

          <div className="flex flex-col sm:flex-row gap-4 mb-12 lg:mb-0">
            <motion.a 
              href={WHATSAPP_URL}
              className="bg-slate-900 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-slate-800 transition-all flex items-center justify-center shadow-lg hover:shadow-2xl"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Pedir Oferta por WhatsApp
            </motion.a>
            <motion.a 
              href="#caracteristicas"
              className="bg-white text-slate-900 border-2 border-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-slate-50 transition-all flex items-center justify-center"
              whileHover={{ scale: 1.02 }}
            >
              Ver Detalles
            </motion.a>
          </div>
        </motion.div>
        
        <motion.div 
          className="lg:w-1/2 relative w-full"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div className="absolute -inset-4 bg-slate-200 rounded-full blur-3xl opacity-30 animate-pulse"></div>
          <motion.img 
            src={IMAGES.hero} 
            alt="Mesa de Centro de Acero DECOMAST" 
            className="relative z-10 w-full h-auto rounded-2xl shadow-2xl object-contain lg:object-cover lg:aspect-square"
            animate={{ y: [0, -15, 0] }}
            transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
